import { StateScheme } from 'app/providers/StoreProvider/config/StateScheme'

export const getPublicDate = (state: StateScheme) => {
    return state.updateDate.public_date
}
